import ExportButton from 'components/Common/ExportButton';
import ToolBarButton from 'components/Common/ToolbarButton';
import React from 'react';
import { DataValue } from 'react-apollo';
import intl from 'react-intl-universal';
import { RoomSystem } from '../../typings/types';

interface Props {
  data: DataValue<RoomSystem>;
  canDelete: boolean;
  canUnpair: boolean;
  canCustomize: boolean;
  hasSelected: boolean;
  isExporting: boolean;
  confirmRemoveFromCloud: () => void;
  confirmDeleteFromCloud: () => void;
  openHdPhonePreferences: () => void;
  handleExportData: () => void;
  selectionArray: Array<string>;
}

const RoomSystemsToolBar = (
  {
    canDelete,
    canUnpair,
    canCustomize,
    hasSelected,
    confirmRemoveFromCloud,
    confirmDeleteFromCloud,
    openHdPhonePreferences,
    handleExportData,
    isExporting
  }: Props) => {

  const onExportClick = () => {
    handleExportData();
  };

  return (
    <div className="toolbar" data-test="toolbar">
      <div>
        <ExportButton
          disabled={isExporting}
          isExporting={isExporting}
          onExportClick={onExportClick}
        />
        <ToolBarButton
          clickHandler={openHdPhonePreferences}
          disabledTooltipText={intl.get('tooltipNoneSelectedRoomSystems')}
          isEnabled={canCustomize}
          label={intl.get('customizeSelectedPhones')}
          showWarningText={!canCustomize && hasSelected}
          warningTooltipText={intl.get('tooltipPhoneHD')}
        />
        <ToolBarButton
          clickHandler={confirmRemoveFromCloud}
          disabledTooltipText={intl.get('tooltipNoneSelectedRoomSystems')}
          isEnabled={canUnpair}
          label={intl.get('removeFromCloud')}
          showWarningText={!canUnpair && hasSelected}
          warningTooltipText={intl.get('tooltipUnpair')}
        />
        <ToolBarButton
          clickHandler={confirmDeleteFromCloud}
          disabledTooltipText={intl.get('tooltipNoneSelectedRoomSystems')}
          isEnabled={canDelete}
          label={intl.get('delete')}
          showWarningText={!canDelete && hasSelected}
          tooltipIsOnRight={true}
          warningTooltipText={intl.get('tooltipDelete')}
        />
      </div>
    </div>
  );
};

export default RoomSystemsToolBar;
